module.exports = __webpack_public_path__ + "img/dentalia.4374867a.jpg";